import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useLocation, useNavigate } from "react-router-dom";
import {
  BottomNavigationAction,
  BottomNavigation,
  Stack,
  Box,
} from "@mui/material";
import {
  AccountCircle as AccountCircleIcon,
  Sms as SmsIcon,
  Spa as SpaIcon,
} from "@mui/icons-material";

import getLPTheme from "../getLPTheme";

const App = ({ children, top }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const lightTheme = createTheme(getLPTheme("light"));

  return (
    // renstart
    <ThemeProvider theme={lightTheme} sx={{ height: "100%" }}>
      <Stack
        className="App"
        sx={{
          justifyContent: "space-between",
        }}
      >
        <Box>{top}</Box>
        <Box sx={{ overflowY: "auto", height: "100%" }}>{children}</Box>
        <Box>
          <BottomNavigation
            showLabels
            value={""}
            sx={{
              width: "100%",
              p: 0,
              display: "flex",
              borderTop: "1px solid #e3e3e3",
              zIndex: 1299, // greate than swipable drawer 1300
            }}
            onChange={(event, newValue) => {
              if (newValue == "account") {
                navigate("/account");
              } else if (newValue == "services") {
                navigate("/");
              } else if (newValue == "chats") {
                navigate("/chats");
              }
              //                 navigate('/login');
              //             } else if (/\/users\/\d+\/enable/.test(pathname)) {
            }}
          >
            <BottomNavigationAction
              sx={{
                color: pathname == "/" ? "#76c6ff" : null,
                "&.Mui-selected": {
                  color: "crimson",
                },
              }}
              label="Cервисы"
              value={"services"}
              icon={<SpaIcon />}
            />
            <BottomNavigationAction
              sx={{
                color: pathname == "/chats" ? "#76c6ff" : null,
                "&.Mui-selected": {
                  color: "crimson",
                },
              }}
              label="Чаты"
              value={"chats"}
              icon={<SmsIcon />}
            />
            <BottomNavigationAction
              sx={{
                color: pathname == "/account" ? "#76c6ff" : null,
                "&.Mui-selected": {
                  color: "crimson",
                },
              }}
              label="Aккаунт"
              value={"account"}
              icon={<AccountCircleIcon />}
            />
          </BottomNavigation>
        </Box>
      </Stack>
    </ThemeProvider>
  );
};

export default App;
